import { Component } from '@angular/core';

import { BaseChartComponent } from './base-chart/base-chart.component';

@Component({
  selector: 'cam-line-chart',
  templateUrl: './base-chart/base-chart.component.html',
  styleUrls: ['./base-chart/base-chart.component.scss'],
})
export class CamChartLineComponent extends BaseChartComponent<'line'> {
  constructor() {
    super();

    this.type = 'line';
  }
}
